export const AUTH_TOKEN = 'access_token';
export const AUTH_REFRESH_TOKEN = 'refresh_token';
export const AUTH_USER = 'user';